import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Body1 } from '@/components/@IntranetLibrary/Typography';

const AIPanel: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#111315',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          padding: '16px 20px',
          borderBottom: '1px solid #1F2327',
        }}
      >
        <Typography
          sx={{
            color: '#FFFFFF',
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '28px',
          }}
        >
          AI Chat
        </Typography>
      </Box>

      {/* Content Area - Placeholder */}
      <Box
        sx={{
          flex: 1,
          padding: '24px 20px',
          overflowY: 'auto',
        }}
      >
        <Stack spacing={2}>
          <Body1 sx={{ color: '#999999' }}>AI 기능이 곧 추가됩니다.</Body1>
          <Box
            sx={{
              padding: '16px',
              backgroundColor: '#1A1A1A',
              borderRadius: '8px',
              border: '1px solid #1F2327',
            }}
          >
            <Body1 sx={{ color: '#CCCCCC' }}>
              이 영역에 파일 요약, 질문-답변, 핵심 내용 추출 등의 AI 기능이
              표시됩니다.
            </Body1>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default AIPanel;
